export class AuthenticationError {
  public CustomErrorCode: number;
  public ErrorTitle: string;
  public ErrorDescription: string;
  public RedirectActionURL: string;
  public RedirectActionDescription: string;
}
